// ==============================|| DEFAULT THEME - TYPOGRAPHY  ||============================== //

const Typography = (fontFamily) => ({
    htmlFontSize: 16,
    fontFamily,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h1: {
        fontWeight: 600,
        fontSize: '2.375rem',
        lineHeight: 1.21
    },
    h2: {
        fontWeight: 600,
        fontSize: '1.875rem',
        lineHeight: 1.27
    },
    h3: {
        fontWeight: 400,
        fontSize: '4rem',
        lineHeight: '4.904rem',
        fontWeightBold: 700,
        fontWeightMedium: 600,
        fontWeightRegular: 400

    },
    h4: {
        fontWeight: 600,
        fontSize: '1.25rem',
        lineHeight: 1.4
    },
    h5: {
        fontWeight: 400,
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
        fontWeightBold: 700,
        fontWeightMedium: 600,
        fontWeightRegular: 400
    },
    h6: {
        fontWeight: 400,
        fontSize: '0.75rem',
        lineHeight: 'normal',
        fontWeightBold: 700,
        fontWeightMedium: 600,
        fontWeightRegular: 400
    },
    caption: {
        fontWeight: 400,
        fontSize: '0.75rem',
        lineHeight: 1.66
    },
    body: {
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: 'normal',
        fontWeightBold: 700,
        fontWeightMedium: 600,
        fontWeightRegular: 400
    },
    bodyMedium: {
        fontSize: '1rem',
        lineHeight: 'normal',
        fontWeight: 600,
        fontStyle: 'normal'
    },
    body1: {
        fontSize: '0.875rem',
        lineHeight: 1.57
    },
    body2: {
        fontSize: '0.75rem',
        lineHeight: 1.66
    },
    subtitle1: {
        fontSize: '0.875rem',
        fontWeight: 600,
        lineHeight: 1.57
    },
    subtitle2: {
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: 1.66
    },
    overline: {
        lineHeight: 1.66
    },
    button: {
         textTransform: 'none',
        lineHeight: 'normal'
    }
});

export default Typography;
